$(function () {
  //////////// 一番目以外のコンテンツは非表示
  $(".pg-p-container__contents:not(:first-of-type)").css("display", "none");
  $("#s-container").show();
  //////////// タブの制御
  $('.pg-p-container__menu-content').click(function () { // タブメニューをhoverしたら
    var index = $('.pg-p-container__menu-content').index(this); // hoverしたタブ番号を取得
    $('.pg-p-container__menu-content').removeClass('current'); // タブ現在地クラスを削除し、
    $(this).addClass('current'); // hoverしたタブにタブ現在地クラスを付与
    //////////// コンテンツの制御
    $('.pg-p-container__contents').hide().eq(index).show(); // hoverしてないコンテンツは非表示、hoverした番号は表示
 
    });

	/**
	 * 地域ごとの料金表モーダル
	 */
	$('.pg-p-container__contents-main-text-box').find('.area-price').on('click',function(){
		$('.pg-p-container__contents-modal').fadeIn();
        return false;
    });
	$('.s-price-modal-btn').on('click',function(){
		$('.m-price-modal-th').removeClass('active-th');
		$('.m-price-modal').removeClass('active-td');
		$('.l-price-modal-th').removeClass('active-th');
		$('.l-price-modal').removeClass('active-td');
		$('.lh-price-modal-th').removeClass('active-th');
		$('.lh-price-modal').removeClass('active-td');
		$('.s-price-modal-th').addClass('active-th');
		$('.s-price-modal').addClass('active-td');
        return false;
    });
	$('.m-price-modal-btn').on('click',function(){
		$('.s-price-modal-th').removeClass('active-th');
		$('.s-price-modal').removeClass('active-td');
		$('.l-price-modal-th').removeClass('active-th');
		$('.l-price-modal').removeClass('active-td');
		$('.lh-price-modal-th').removeClass('active-th');
		$('.lh-price-modal').removeClass('active-td');
		$('.m-price-modal-th').addClass('active-th');
		$('.m-price-modal').addClass('active-td');
        return false;
    });
	$('.l-price-modal-btn').on('click',function(){
		$('.s-price-modal-th').removeClass('active-th');
		$('.s-price-modal').removeClass('active-td');
		$('.m-price-modal-th').removeClass('active-th');
		$('.m-price-modal').removeClass('active-td');
		$('.lh-price-modal-th').removeClass('active-th');
		$('.lh-price-modal').removeClass('active-td');
		$('.l-price-modal-th').addClass('active-th');
		$('.l-price-modal').addClass('active-td');
        return false;
    });
	$('.lh-price-modal-btn').on('click',function(){
		$('.s-price-modal-th').removeClass('active-th');
		$('.s-price-modal').removeClass('active-td');
		$('.m-price-modal-th').removeClass('active-th');
		$('.m-price-modal').removeClass('active-td');
		$('.l-price-modal-th').removeClass('active-th');
		$('.l-price-modal').removeClass('active-td');
		$('.lh-price-modal-th').addClass('active-th');
		$('.lh-price-modal').addClass('active-td');
        return false;
    });
	
	$('.pg-p-container__contents-modal').find('.pg-p-container__contents-modal-back').on('click',function(){
		$('.pg-p-container__contents-modal').fadeOut();
        return false;
    });
	$('.pg-p-container__contents-modal').find('span').on('click',function(){
		$('.pg-p-container__contents-modal').fadeOut();
        return false;
    });


	/**
	 * 都道府県モーダル
	 */
	$('.pg-p-search-store').find('ul').find('li').find('a').on('click',function(){
		let areaId = $(this).data('areaid');
		$.ajax({
		url: '/api/area/index?area_id='+areaId+'&service=monokura',
		type: 'GET',
		dataType: 'json',
		}).done(function(data) {
			$('.pg-p-search-store-modal').fadeIn();
			$('.pg-p-search-store-modal').find('.pg-p-search-store-modal-content').find('li').remove();
			let list = '';
			for(let i in data['area']) {
				let area = data['area'][i]['area_name']
				let areaId = data['area'][i]['id']
				
				list += '<li><a href="'+data['url'][areaId]+'?service=monokura" target="_blank"><img src="/images/common/icon_house.svg">'+ area+'</a></li>';
					
			}
			$('.pg-p-search-store-modal').find('.pg-p-search-store-modal-content').find('ul').append(list);
		}).fail(function( jqXHR, textStatus, errorThrown) {
			
		
		
	});
		
		
		
    });
	$('.pg-p-search-store-modal').find('.pg-p-search-store-modal-back').on('click',function(){
		$('.pg-p-search-store-modal').fadeOut();
        return false;
    });
	$('.pg-p-search-store-modal').find('span').on('click',function(){
		$('.pg-p-search-store-modal').fadeOut();
        return false;
    });


	$('#s-container-table-open').on('click',function(){
		$("#s-container-table").slideToggle();
		$(this).toggleClass('on');
        return false;
    });
	$('#m-container-table-open').on('click',function(){
		$("#m-container-table").slideToggle();
		$(this).toggleClass('on');
        return false;
    });
	$('#l-container-table-open').on('click',function(){
		$("#l-container-table").slideToggle();
		$(this).toggleClass('on');
        return false;
    });
	$('#lh-container-table-open').on('click',function(){
		$("#lh-container-table").slideToggle();
		$(this).toggleClass('on');
        return false;
    });
});